import axios from 'axios';
import React, { useState, useEffect } from "react";
import { Nav, NavLink } from "./Allcss/NavbarElements";
import Typography from "@mui/material/Typography";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate ,useLocation} from "react-router-dom";
import Swal from 'sweetalert2';
import { Backdrop, CircularProgress, useMediaQuery, useTheme } from '@mui/material';
import { BASE_URL } from "../App";
import Dashboard from './dashboard/dashbord';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Dialog, DialogActions, DialogContent, Button,Box, DialogTitle,IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; 
const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Use location to detect route changes
  const [menuItems, setMenuItems] = useState([]);
  const [popupData, setPopupData] = useState(null);
  const [image, setimage] = useState(null);
  const [openPopup, setOpenPopup] = useState(false); 
  const [balanceconfirmm, setBalanceconfirm] = useState('');
  const [loading, setloading] = React.useState(false);
  const [limit, setLimit] = useState(5); // Set your desired default limit here
  const login_id = localStorage.getItem("LOGIN_ID");
  const usertype = localStorage.getItem("usertype");

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component is mounted or navigated to
  }, [location]); // Trigger scroll on route change
  useEffect(() => {
    if (!login_id) {
      Swal.fire({
        icon: "warning",
        text: 'Login Failed!',
      });
      navigate('/');
      navigate('/Login');
    } else {
      balanceconfirm(); // Trigger balance confirmation when login is successful
    }
  }, [login_id]);

  const handleClosePopup = () => {
    setOpenPopup(false); 
  };
  useEffect(() => {
    
    if (usertype === '3' && balanceconfirmm === 'V') {
      
      Swal.fire({
        title: 'Balance Confirmation',
        text: 'Please Authenticate The Balance Confirmation',
        icon: 'info',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/Home/Dealer/Balance_Confirmation_Letter');
        
        } else {
          console.log('User did not confirm balance');
          setloading(false); // Stop loading if user does not confirm
        }
      });
    } else if (usertype !== '3') {
     
      fetchData();
    }
    else if (usertype === '3' && balanceconfirmm !== 'V') {
      if (balanceconfirmm !== '') {
        schemepopup()
        fetchData(); 
      }
      
    }
  }, [usertype, balanceconfirmm]);
  
  const schemepopup = async () => {
    setloading(true);
    try {
      const response = await axios.post(BASE_URL + '/dealerschemepopup', {
        dealer_code: login_id,
      });
      
      
      if (response.data.schemepopup && response.data.schemepopup.length > 0) {
        setPopupData(response.data.schemepopup[0]);
        setimage(response.data.image_1);
        setOpenPopup(true);
      }

      setloading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setloading(false);
    }
  };
  const fetchData = async () => {
   
    setloading(true);
    try {
      const response = await axios.post(BASE_URL + '/homeMenuList',
        {
          "MENU_NAME": 'HOME',
          "login_id": login_id,
        }
      );
      console.log("API Response:", response.data.menulist);
      setMenuItems(response.data.menulist);
      setloading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setloading(false);
    }
  };

  const balanceconfirm = async () => {
    setloading(true);  // Show loading indicator
    try {
      const response = await axios.post(BASE_URL + '/authenticatebalanceconfirmation', {
        login_id: login_id,
      });
  
      console.log('API Response:', response.data);
  
      
      if (response.data.status_code === '200' && response.data.authenticatebalanceconfirmation.length > 0) {
       
        const status = response.data.authenticatebalanceconfirmation[0].status;
  
        
        setBalanceconfirm(status);  
  
        console.log('Balance Confirmation Status:', status);
      } else {
      
        setBalanceconfirm(''); 
      }
    } catch (error) {
      console.error('Error fetching balance confirmation:', error);
      setBalanceconfirm(''); 
    } finally {
      setloading(false);  
    }
  };
  

  const handleNavLinkClick = (selectedUrlName) => {
    localStorage.setItem("MENU_NAME", selectedUrlName);
  };

  const increaseLimit = () => {
    // Increment the limit by a desired value, for example, 5
    setLimit(prevLimit => prevLimit + 5);
  };


  
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <style>{`
        .zoom {
          transition: transform .2s;
        }

        .zoom:hover i{
          -ms-transform: scale(1.5); /* IE 9 */
          -webkit-transform: scale(1.5); /* Safari 3-8 */
          transform: scale(1.5); 
        }
        .navbar-container {
          position: relative;
          overflow-x: auto; /* Enable horizontal scrolling */
        }
      `}</style>
       <div>
		  { usertype == '3' && balanceconfirmm !== 'V' ? (
			<Dashboard />
		  )  : (
			null
		  )}
      </div>
      <Nav className="navbar-container"> 
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', padding: '8px' }}>
         {menuItems.map((menuItem) => (
  menuItem.urlname === 'Digital Library' ? (
    <a
      key={menuItem.id}
      href={menuItem.urlpath}
      target="_blank"
      rel="noopener noreferrer" // Important for security reasons
      className={`zoom`}
      style={{
        width: isXs ? '110px' : isSm ? '110px' : '110px',
        height: isXs ? '110px' : isSm ? '110px' : '110px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '8px',
        padding: '8px',
        borderRadius: '8px',
        background: 'rgba(255, 255, 255, 0.2)', 
        backdropFilter: 'blur(10px)', 
        WebkitBackdropFilter: 'blur(10px)', 
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)', 
        border: '1px solid rgba(255, 255, 255, 0.18)', 
      }}
      onClick={() => handleNavLinkClick(menuItem.urlname)}
    >
      <i
        className={`${menuItem.icon} `}
        style={{
          fontSize: isXs ? '24px' : isSm ? '24px' : '24px',
          color: 'white',
        }}
      ></i>
      <Typography variant="body1" style={{ fontSize: '14px', color: 'white', textAlign: 'center', marginTop: '8px' }}>
        {menuItem.urlname}
      </Typography>
    </a>
  ) : (
    <NavLink
      key={menuItem.id}
      to={menuItem.urlpath}
      className={`zoom`}
      style={{
        width: isXs ? '110px' : isSm ? '110px' : '110px',
        height: isXs ? '110px' : isSm ? '110px' : '110px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '8px',
        padding: '8px',
        borderRadius: '8px',
        background: 'rgba(255, 255, 255, 0.2)', 
        backdropFilter: 'blur(10px)', 
        WebkitBackdropFilter: 'blur(10px)', 
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)', 
        border: '1px solid rgba(255, 255, 255, 0.18)', 
      }}
      onClick={() => handleNavLinkClick(menuItem.urlname)}
    >
      <i
        className={`${menuItem.icon} `}
        style={{
          fontSize: isXs ? '24px' : isSm ? '24px' : '24px',
          color: 'white',
        }}
      ></i>
      <Typography variant="body1" style={{ fontSize: '14px', color: 'white', textAlign: 'center', marginTop: '8px' }}>
        {menuItem.urlname}
      </Typography>
    </NavLink>
  )
))}
        </div>
      </Nav>
<div>
<Dialog 
  open={openPopup && popupData} 
  onClose={handleClosePopup} 
  maxWidth="lg" 
  fullWidth 
  data-aos="flip-left"
  data-aos-easing="ease-out-cubic"
  data-aos-duration="5000"
>
<DialogTitle sx={{ position: 'relative' }}>
        {/* Close button positioned in the top-right corner */}
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClosePopup}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
  <DialogContent
    sx={{
      overflowY: 'auto',
      maxHeight: '80vh',
      '&::-webkit-scrollbar': { width: '8px' },
      '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.background.default, borderRadius: '10px' },
      '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.primary.main, borderRadius: '10px', border: '2px solid white' },
      '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.primary.dark }
    }}
  >
    {popupData ? (
      <div style={{ textAlign: 'center' }}>
        <img
              src={`data:image/jpeg;base64,${image}`} 
          alt="Scheme Image"
          style={{ maxHeight:'100%',maxWidth:'100%', marginBottom: '20px' }}
        />
        <Box sx={{ padding: 2 }}>
          {popupData.MESSAGE1 && (
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, marginBottom: 2, textAlign: 'center', textTransform: 'uppercase', letterSpacing: 1 }}>
              {popupData.MESSAGE1}
            </Typography>
          )}
           {popupData.MESSAGE2 && (
            <Typography
              variant="body1"
              sx={{
                background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', // Light gradient
                color: '#2c3e50', // Dark text for contrast
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '12px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
                fontWeight: '500',
                textAlign: 'left',
                fontSize: '1rem',
                letterSpacing: '0.5px',
              }}
              paragraph
            >
            <b>  {popupData.MESSAGE2}</b>
            </Typography>
          )}

          {popupData.MESSAGE3 && (
            <Typography
              variant="body1"
              sx={{
                background: 'linear-gradient(135deg, #e0eafc, #cfdef3)', // Soft blue gradient
                color: '#2c3e50', // Dark text for contrast
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '12px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
                fontWeight: '500',
                textAlign: 'left',
                fontSize: '1rem',
                letterSpacing: '0.5px',
              }}
              paragraph
            >
          <b>    {popupData.MESSAGE3}</b>
            </Typography>
          )}

          {popupData.MESSAGE4 && (
            <Typography
              variant="body1"
              sx={{
                background: 'linear-gradient(135deg, #f0f4f8, #d9e2ec)', // Light gray gradient
                color: '#2c3e50', // Dark text for contrast
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '12px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
                fontWeight: '500',
                textAlign: 'left',
                fontSize: '1rem',
                letterSpacing: '0.5px',
              }}
              paragraph
            >
             <b> {popupData.MESSAGE4}</b>
            </Typography>
          )}

          {popupData.MESSAGE5 && (
            <Typography
              variant="body1"
              sx={{
                background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)', // Off-white gradient
                color: '#2c3e50', // Dark text for contrast
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '12px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
                fontWeight: '500',
                textAlign: 'left',
                fontSize: '1rem',
                letterSpacing: '0.5px',
              }}
              paragraph
            >
             <b> {popupData.MESSAGE5}</b>
            </Typography>
          )}

          {popupData.MESSAGE6 && (
            <Typography
              variant="body1"
              sx={{
                background: 'linear-gradient(135deg, #f1f3f5, #dee2e6)', // Light gray gradient
                color: '#2c3e50', // Dark text for contrast
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '12px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
                fontWeight: '500',
                textAlign: 'left',
                
                fontSize: '1rem',
                letterSpacing: '0.5px',
              }}
              paragraph
            >
             <b> {popupData.MESSAGE6}</b>
            </Typography>
          )}
        </Box>
      </div>
    ) : (
      ''
    )}
  </DialogContent>
  <DialogActions>
    
    {/* <Button onClick={handleClosePopup} color="primary">
      Close
    </Button> */}
  </DialogActions>
</Dialog>
</div>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Navbar;
